import { render } from "./pluginPropEdit.vue?vue&type=template&id=4af16046&scoped=true&ts=true"
import script from "./pluginPropEdit.vue?vue&type=script&lang=ts"
export * from "./pluginPropEdit.vue?vue&type=script&lang=ts"

import "./pluginPropEdit.vue?vue&type=style&index=0&id=4af16046&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af16046"]])

export default __exports__